import {
  Component,
  Prop,
  Element,
  Event,
  EventEmitter,
  h,
  Listen,
  Host,
} from "@stencil/core";
import { Bundle } from "../../../../services/i18n";

import { ProductPrice } from "../../ProductPrice";

@Component({
  tag: "scs-autocomplete-product-option",
  styleUrls: ["autocomplete-product-option.scss"],
  shadow: true,
})
export class AutocompleteProductOption {
  private autocompleteEl!: HTMLScsAutocompleteElement;

  @Element() host!: HTMLScsAutocompleteProductOptionElement;
  /** @internal defines if current option is displayed as focused, only used by autocomplete element */
  @Prop() hasFocus: boolean = false;
  /** href to link the item  */
  @Prop() href: string = "javascript:void(0)";
  /** image url to display */
  @Prop() imageUrl: string = "";
  /** product name used for title tag an img */
  @Prop() name: string = "";
  /** product installment price */
  @Prop() installmentPrice?: number;
  /** product retail price, will be used if no installmentPrice is availabel  */
  @Prop() retailPrice!: number;

  @Prop() i18n!: Bundle;

  @Event()
  autocompleteOptionLoaded!: EventEmitter<HTMLScsAutocompleteProductOptionElement>;
  @Event()
  autocompleteOptionSelected!: EventEmitter<HTMLScsAutocompleteProductOptionElement>;

  @Listen("click")
  clickHandler() {
    this.autocompleteOptionSelected.emit(this.host);
  }

  @Listen("keydown", { target: "window" })
  keydownHandler(ev: KeyboardEvent) {
    if (ev.key === "Enter" && this.hasFocus) {
      this.autocompleteOptionSelected.emit(this.host);
    }
  }

  get displayPrice(): number | undefined {
    return this.installmentPrice || this.retailPrice;
  }

  componentWillLoad() {
    this.autocompleteEl = this.host.closest(
      "scs-autocomplete",
    ) as HTMLScsAutocompleteElement;
  }

  componentDidLoad() {
    this.autocompleteOptionLoaded.emit(this.host);
  }

  disconnectedCallback() {
    this.autocompleteEl.autocompleteOptionRemoved();
  }

  render() {
    return (
      <Host
        role="option"
        aria-selected={this.hasFocus}
        class={{
          "autocomplete-product-option": true,
          focus: this.hasFocus,
        }}
      >
        <a href={this.href} class="product-link">
          <div class="product-link__image">
            <img src={this.imageUrl} alt="" title={this.name}></img>
          </div>
          <div class="product-link__body">
            <slot />
            <ProductPrice
              retailPrice={this.retailPrice}
              installmentPrice={this.installmentPrice}
              i18n={this.i18n}
            ></ProductPrice>
            <sdx-button
              theme="transparent"
              icon-name="icon-arrow-right"
              icon-size="1"
              label={this.i18n.t("TO_OFFER")}
              sr-hint={this.i18n.t("TO_OFFER")}
            ></sdx-button>
          </div>
        </a>
      </Host>
    );
  }
}
